import React, { useState, useContext } from 'react'
import { observer } from 'mobx-react-lite'
// evertel
import {
    Text,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    Col
} from '@evertel/web/ui'
import { RoomContext } from '../../RoomContext'
import { RoomMediaSearchSelect } from '../RoomMediaSearchSelect'
import { RoomDocumentsSearchSelect } from '../../RoomDocumentsSearchSelect'
import { useDocumentModal } from '@evertel/web/document'
import { RoomExportsTable } from '../RoomExportsTable'

interface RoomMediaSearchProps {
    initialTab?: 'files'|'docs'|'room_exports'
}


const RoomMediaSearch: React.FC<RoomMediaSearchProps> = observer(({
    initialTab = 'files'
}) => {

    const { roomController, asideOpenComplete, canManageRoom } = useContext(RoomContext)
    const { openDocumentModal } = useDocumentModal()
    const room = roomController.room

    const [activeTab, setActiveTab] = useState<'files'|'docs'|'room_exports'>(initialTab)

    if (!room || !asideOpenComplete) return null

    return (
        <Col>
            <Nav
                variant="underline"
                role="tablist"
                style={{
                    fontSize: '.9rem'
                }}>
                <NavItem>
                    <NavLink
                        active={activeTab === 'files'}
                        onClick={() => setActiveTab('files')}>
                        <Text>
                            Files/Images
                        </Text>
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        active={activeTab === 'docs'}
                        onClick={() => setActiveTab('docs')}>
                        <Text>
                            EverDocs
                        </Text>
                    </NavLink>
                </NavItem>
                {canManageRoom &&
                    <NavItem>
                        <NavLink
                            active={activeTab === 'room_exports'}
                            onClick={() => setActiveTab('room_exports')}>
                            <Text>
                                Room Exports
                            </Text>
                        </NavLink>
                    </NavItem>
                }
            </Nav>
            <TabContent>
                <TabPane
                    role="tabpanel"
                    visible={activeTab === 'files'}>
                    <div className="pt-3">
                        Find files shared in this room
                    </div>
                    <RoomMediaSearchSelect
                        roomId={room.id}
                        menuIsOpen
                        maxMenuHeight="calc(100vh - 220px)"
                        className="no-bg search space-below"
                    />
                </TabPane>
                <TabPane
                    role="tabpanel"
                    visible={activeTab === 'docs'}>
                    <div className="pt-3">
                        Find EverDocs shared with this room
                    </div>
                    <RoomDocumentsSearchSelect
                        roomId={room.id}
                        onSelect={(doc) => openDocumentModal(doc.id)}
                        menuIsOpen
                        maxMenuHeight="calc(100vh - 220px)"
                        className="no-bg search space-below"
                    />
                </TabPane>
                {canManageRoom &&
                    <TabPane
                        role="tabpanel"
                        visible={activeTab === 'room_exports'}
                    >
                        <div className="pt-3">
                            <Text bold>Export Room to PDF</Text>
                        </div>
                        <div className="mt-2">
                            <small className="fs-5">Room exports are a type of audit available to Executives and Room Managers. Retracted messages are not included.</small>
                        </div>
                        <RoomExportsTable roomId={room?.id}/>
                    </TabPane>
                }
            </TabContent>
        </Col>
    )
})

export { RoomMediaSearch }
